<script lang="ts">
  import type { Snippet } from 'svelte'
  import { getI18n } from '../i18n'
  import SectionHeading from './SectionHeading.svelte'

  let { title, children }: { title: string; children: Snippet } = $props()

  const i18n = getI18n()
</script>

<div class="legal-page">
  <SectionHeading eyebrow="Visit Augsburg">{title}</SectionHeading>
  {#if i18n.locale !== 'de'}
    <p class="legal-page-binding-note">{i18n.t('legal.bindingNote')}</p>
  {/if}
  {@render children()}
</div>

<style>
  .legal-page {
    max-width: var(--content-max-width);
  }

  .legal-page-binding-note {
    margin: var(--space-7) 0 0;
    padding: var(--space-5) var(--space-7);
    border-radius: var(--radius-2);
    background-color: var(--color-variant-warning-muted);
    color: var(--color-variant-warning);
    font-size: var(--font-size-4);
  }
</style>
